import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Alert,
  CircularProgress
} from '@mui/material';
import {
  HourglassEmpty,
  Refresh,
  Home
} from '@mui/icons-material';

const PaymentPending = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const externalReference = searchParams.get('external_reference');
    const paymentId = searchParams.get('payment_id');
    const collectionStatus = searchParams.get('collection_status');
    
    setPaymentInfo({
      externalReference,
      paymentId,
      collectionStatus
    });
  }, [searchParams]);

  const handleCheckStatus = () => {
    setChecking(true);
    // Simular verificación
    setTimeout(() => {
      setChecking(false);
      // Aquí deberías hacer una llamada real al backend
      alert('El pago aún está pendiente. Te notificaremos cuando se confirme.');
    }, 2000);
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', py: 4 }}>
        <Card sx={{ width: '100%' }}>
          <CardContent className="text-center">
            <HourglassEmpty
              sx={{ fontSize: 80, color: 'warning.main', mb: 2 }}
            />
            
            <Typography variant="h4" className="mb-md font-bold">
              Pago Pendiente
            </Typography>
            
            <Typography variant="body1" color="text.secondary" className="mb-lg">
              Tu pago está siendo procesado
            </Typography>

            {paymentInfo?.externalReference && (
              <Box className="mb-lg">
                <Card variant="outlined">
                  <CardContent>
                    <Box className="d-flex justify-between mb-sm">
                      <Typography variant="body2" color="text.secondary">
                        Referencia:
                      </Typography>
                      <Typography variant="body2" className="font-semibold">
                        {paymentInfo.externalReference}
                      </Typography>
                    </Box>
                    
                    <Box className="d-flex justify-between">
                      <Typography variant="body2" color="text.secondary">
                        Estado:
                      </Typography>
                      <Typography variant="body2" className="font-semibold" color="warning.main">
                        Pendiente
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            )}

            <Alert severity="info" className="mb-md">
              <Typography variant="body2" className="mb-xs">
                Motivos comunes de pago pendiente:
              </Typography>
              <Typography variant="caption" component="div">
                • Pago en efectivo (esperando confirmación en punto de pago)<br />
                • Transferencia bancaria (en proceso)<br />
                • Validación adicional del banco<br />
                • Demora en la red de pagos
              </Typography>
            </Alert>

            <Alert severity="success" className="mb-lg">
              Te notificaremos por correo cuando tu pago sea confirmado.
            </Alert>

            <Box className="d-flex gap-sm justify-center mb-md">
              <Button
                variant="outlined"
                startIcon={checking ? <CircularProgress size={20} /> : <Refresh />}
                onClick={handleCheckStatus}
                disabled={checking}
              >
                {checking ? 'Verificando...' : 'Verificar Estado'}
              </Button>
              <Button
                variant="contained"
                startIcon={<Home />}
                onClick={() => navigate('/')}
              >
                Volver al Inicio
              </Button>
            </Box>

            <Typography variant="caption" color="text.secondary">
              La confirmación puede tardar hasta 48 horas dependiendo del método de pago.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default PaymentPending;

